import ContentListingItem from "./ContentListingItem.jsx";
import { array } from "prop-types";

const propTypes = { results: array };

const VariantOne = (props) => {
  const { results } = props;

  return (
    <div className="dynamic-content-listing__variant-one">
      <div className="dynamic-content-listing__results-row dynamic-content-listing__results-row--three-up">
        {results?.map((item, i) => (
          <ContentListingItem key={item.title} displayImage={true} {...item} />
        ))}
      </div>
    </div>
  );
};

VariantOne.propTypes = propTypes;
export default VariantOne;
